module.exports = __webpack_public_path__ + "img/cancercouncil-vic.397e5cf.png";